import { Modal, Button, Row, Col } from "react-bootstrap";
import { useState } from "react";

export default function RecapModal({ show, onClose, booking }) {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  if (!booking) return null;

  const handleConfirm = async () => {
    setLoading(true);
    setError("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BAC_URL}/mail/new-reservation`,
        {
          method: "POST",
          headers: {
            Authorization: "bearer 1654551514hhgfhfb45665454",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            nom: booking.name,
            prenom: booking.firstname,
            email: booking.email,
            phone: booking.phone,
            date: booking.date,
            heure: booking.heure,
            adresseDepart: booking.depart,
            adresseArrive: booking.arrivee,
            serviceType: booking.serviceType,
            passagers: booking.passagers,
            bagages: booking.bagages,
            options: booking.options,
            info: booking.demandes,
            distance: booking.distance,
            duree: booking.duree,
            prix: booking.prix,
          }),
        }
      );

      if (!response.ok) {
        throw new Error("Erreur serveur");
      }

      setSuccess(true);
    } catch (err) {
      setError("Une erreur est survenue lors de l’envoi. Veuillez réessayer.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      centered
      size="lg"
      dialogClassName="recap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>Récapitulatif de votre réservation</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col md={6}>
            <h6>Trajet</h6>
            <p>
              <strong>Départ :</strong> {booking.depart}
            </p>
            <p>
              <strong>Arrivée :</strong> {booking.arrivee}
            </p>
            <p>
              <strong>Date :</strong> {booking.date}
            </p>
            <p>
              <strong>Heure :</strong> {booking.heure}
            </p>
          </Col>

          <Col md={6}>
            <h6>Course</h6>
            <p>
              <strong>Service :</strong> {booking.serviceType}
            </p>
            <p>
              <strong>Distance :</strong> {booking.distance} km
            </p>
            <p>
              <strong>Durée :</strong> {booking.duree} min
            </p>
            <p>
              <strong>Prix estimé :</strong> {booking.prix} €
            </p>
          </Col>
        </Row>

        {booking.demandes && (
          <>
            <h6 className="mt-3">Demandes spécifiques</h6>
            <p>{booking.demandes}</p>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        {error && <div className="recap-error w-100 mb-2">{error}</div>}

        <Button
          variant="outline-secondary"
          onClick={onClose}
          disabled={loading}
          className="modifier-btn"
        >
          Modifier
        </Button>

        <Button
          className="btn-primary-gold"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Envoi…
            </>
          ) : (
            "Confirmer la réservation"
          )}
        </Button>
      </Modal.Footer>
      {success && (
        <Modal show centered onHide={() => (window.location.href = "/")}>
          <Modal.Body className="text-center p-4">
            <h4 className="mb-3">Réservation confirmée ✅</h4>
            <p>
              Votre demande a bien été envoyée.
              <br />
              Vous recevrez une confirmation par email.
            </p>
            <Button
              className="btn-primary-gold mt-3"
              onClick={() => (window.location.href = "/")}
            >
              Retour à l’accueil
            </Button>
          </Modal.Body>
        </Modal>
      )}
    </Modal>
  );
}
